// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import api from './api/index.js'
import secureApi from './api/secure-api.js'
import $ from 'jquery'
import utils from './utils/index.js'
import axios from 'axios'

Vue.config.productionTip = false
Vue.prototype.$api = api
Vue.prototype.$secureApi = secureApi
Vue.prototype.$utils = utils
Vue.prototype.$axios=axios
Vue.prototype.$baseUrl = process.env.BASE_URL

import VueAwesomeSwiper from 'vue-awesome-swiper'
Vue.use(VueAwesomeSwiper)
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)

 axios.defaults.withCredentials = true; // 允许携带cookie
// 多语言实例
const i18n = new VueI18n({
  locale: (function () {
    if (localStorage.getItem('lang')) {
      return localStorage.getItem('lang')
    }
    return 'bur'
  }()),
  messages: {
    'bur': require('./assets/i18n/bur'),   // 中文语言包
    'en': require('./assets/i18n/en')    // 英文语言包
   // 'my': require('./assets/i18n/my')    // 英文语言包
  }
})

router.beforeEach((to, from, next) => {
	// to来自  from  去哪
	if(to.meta.title) {
		document.title = to.meta.title
	}
	next()
})

let baseDownloadUrl = '' // 域名
    Vue.directive('down', {
      inserted: (el, binding) => {
        el.style.cssText = 'cursor: pointer;color:write;'
        el.addEventListener('click', () => {
          console.log(binding.value)
          let link = document.createElement('a')
          let url = baseDownloadUrl + binding.value
          console.log(url)
          // 这里是将url转成blob地址，
          fetch(url).then(res => res.blob()).then(blob => { // 将链接地址字符内容转变成blob地址
            link.href = window.URL.createObjectURL(blob)
            console.log(link.href)
            link.download = ''
            document.body.appendChild(link)
            link.click()
          })
        })
      }
    })

import { List } from 'vant';
Vue.use(List);
/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js